import { ToneAudioNode, Channel, Meter, gainToDb } from "tone";
import units from "./units.json"
import { clamp } from "./utils/math"

export class GrufBus extends ToneAudioNode {
    static parametersDescription = {
        gain: {type: 'float', display: "db", unit: units.decibel, min: 0, max: 2.0, initial: 1.0, bind: "preset"},
        pan: {type: 'float', min: -1, max: 1, initial: 0, bind: "preset"},
        isMute: {type: 'bool', initial: false },
        isSolo: {type: 'bool', initial: false },
    }
    constructor() {
        super();
        this.masterChannel = new Channel({channelCount: 2});
        this.muteChannel = new Channel({channelCount: 2});
        this.meter = new Meter({channelCount: 2, channels: 2});
        this.masterChannel.fan(this.muteChannel, this.meter);
        this.input = this.masterChannel;
        this.output = this.muteChannel;
    }

    dispose() {
        this.masterChannel.dispose();
        this.muteChannel.dispose();
        this.meter.dispose();
    }

    set gain(value) {
        const volume = gainToDb(value);
        this.masterChannel.volume.linearRampTo(volume, 0.01);
    }

    set pan(value) {
        this.masterChannel.pan.linearRampTo(value, 0.01);
    }

    getCurrentLevels() {
        return this.meter.getValue().map(dBFSLevel => {
            const dBuLevel = dBFSLevel + 18;
            return clamp(dBuLevel, -60, 6);
        })
    }
}